import React, { useEffect, useState } from 'react';
import { useFormikContext } from 'formik';
import styles from './ResponseAiForm.module.scss';
import TextEditor from 'component/atom/forms/text-editor/TextEditor';
import Select from 'component/atom/forms/select/select/Select';
import TextArea from 'component/atom/forms/text-area/TextArea';
import { useFetch } from 'hooks/useFetch';
import { variableManagement, workflow } from 'hooks/endpoints';
import MultiSelectList from 'component/atom/forms/select/multi-select-list/MultiSelectList';
import { useParams } from 'react-router-dom';
import Toggle from 'component/atom/forms/toggle/Toggle';

const ResponseAiForm = ({ knowledgeBaseData }) => {
  const formik = useFormikContext();
  const { id } = useParams();
  const [themesOptions, setThemesOptions] = useState([]);
  const { data, isFetching, refetch } = useFetch(
    ['variableManagement'],
    variableManagement.get,
    { enabled: true },
    { pageSize: 1000, pageNumber: 1 },
  );
  const { data: themes, isFetching: isLoading } = useFetch(
    ['themesByWorkflowId'],
    workflow.getThemesByWorkFlowId(id),
  );

  useEffect(() => {
    if (data?.items) {
      const selectedVariable = data.items.find(
        (item) => item.variableId === formik.values.variableId,
      )?.variableName;
      formik.setFieldValue('variableName', selectedVariable || '');
    }
  }, [formik.values.variableId, data]);

  const typeOptions = data?.data?.items?.map((item) => ({
    value: item.variableId,
    label: item.variableName,
  }));

  let knowledgeBaseOptions = knowledgeBaseData?.data?.items?.map((item) => ({
    value: item.companyMaterialId,
    label: item.folderName ?? item.materialFileName,
    type: item.isURL ? 1 : item.isFolder,
  }));

  useEffect(() => {
    setThemesOptions([
      {
        value: 1,
        label: 'Default',
      },
      ...(Array.isArray(themes?.data?.items)
        ? themes.data.items.map((item) => ({
            value: item.value,
            label: item.label,
          }))
        : []),
    ]);
  }, [themes]);

  return (
    <form
      className={styles['response-ai-form']}
      onSubmit={formik.handleSubmit}
      onKeyDown={(e) => {
        // if (e.key === 'Enter') {
        //   e.preventDefault();
        // }
      }}
    >
      {/* <div className={styles['radio-container']}>
        <RadioGroup
          label="Data Source"
          name="dataSource"
          options={options}
          selectedValue={formik.values.dataSource}
          onChange={formik.handleChange}
          error={formik.errors.dataSource}
          touched={formik.touched.dataSource}
        />
      </div> */}

      <TextEditor
        name='question'
        label='Question'
        value={formik.values.question}
        onChange={(value) => formik.setFieldValue('question', value)}
        onBlur={formik.handleBlur}
        error={formik.errors.question}
        touched={formik.touched.question}
        isToolbarReduced
        isCustom
        className={styles.editor}
        textEditorClassName={styles['editor-class']}
      />

      <MultiSelectList
        label='Knowledge Base'
        name='aiMaterials'
        placeholder='Select Knowledge Base'
        value={formik.values.aiMaterials}
        options={[
          {
            value: 'all',
            label: 'All',
          },
          ...(knowledgeBaseOptions || []),
        ]}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.errors.aiMaterials}
        touched={formik.touched.aiMaterials}
        isFolder
        isAll
      />
      <div className={styles['toggle-container']}>
        <div className={styles.label}>
          <h6>Include References</h6>
          <p className={styles['toggle-desc']}>
            <span
              key={formik.values.isReferenceIncluded ? 'on' : 'off'}
              className={styles['toggle-desc-text']}
            >
              {formik.values.isReferenceIncluded
                ? 'AI will cite knowledge base sources in responses'
                : 'AI will respond without source citations'}
            </span>
          </p>
        </div>
        <Toggle
          name='isReferenceIncluded'
          value={Boolean(formik.values.isReferenceIncluded)}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.errors.isReferenceIncluded}
          touched={formik.touched.isReferenceIncluded}
        />
      </div>

      <TextArea
        label='Prompt Description'
        name='promptDescription'
        placeholder='Enter Description'
        value={formik.values.promptDescription}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.errors.promptDescription}
        touched={formik.touched.promptDescription}
        isExpanded
        cols='50'
        minHeight='50vh'
      />
      <Select
        label='response Theme '
        name='responseThemeId'
        placeholder='Select Response Theme'
        value={formik.values.responseThemeId}
        options={themesOptions}
        // options={themes?.data?.items}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.errors.responseThemeId}
        touched={formik.touched.responseThemeId}
        isLoading={isLoading}
      />
      <Select
        label='Output Variable'
        name='outputVariableId'
        placeholder='Select Output Variable'
        value={formik.values.outputVariableId}
        options={typeOptions}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.errors.outputVariableId}
        touched={formik.touched.outputVariableId}
        isLoading={isFetching}
      />
    </form>
  );
};

export default ResponseAiForm;
